import { useAuth } from '@/hooks';
import { usePermissionGuard } from '@/hooks/usePermissionGuard';
import {
  Avatar,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { SUPPORT_HOME_URL } from '@/constants/app-constants';
import { useKFlags } from '@/hooks/use-k-flags';

export const UserProfile = () => {
  const { currUser: user, logout } = useAuth();
  const history = useHistory();
  const { isAccountInviteEnabled } = usePermissionGuard();
  const { ats_enabled } = useKFlags();

  const onLogout = async () => {
    await logout();
  };

  const redirectToURL = () => {
    window.open(`${SUPPORT_HOME_URL}`, '_blank');
  };

  const handleInviteMember = () => {
    let link = '/settings/users-roles';
    if (ats_enabled) {
      link = '/settings/users';
    }
    history.push(link);
  };

  const menuItemsConfig = [
    ats_enabled && {
      id: 'profile-settings',
      label: 'Profile settings',
      onClick: () => {
        history.push('/settings/profile-settings');
      },
      enabled: isAccountInviteEnabled,
    },
    !ats_enabled && {
      id: 'invite-teammates',
      label: 'Invite teammates',
      onClick: handleInviteMember,
      enabled: isAccountInviteEnabled,
    },
    {
      id: 'help-support',
      label: 'Help & Support',
      onClick: redirectToURL,
      enabled: true,
    },
    { id: 'logout', label: 'Logout', onClick: onLogout, enabled: true },
  ].filter(Boolean);

  const renderAction = () => {
    return (
      <Menu>
        <Flex borderRadius="6px" alignItems="center" cursor="pointer">
          <MenuButton w="full" data-test-id="user-profile">
            <Avatar
              name={`${user?.first_name} ${user?.last_name}`}
              src={user?.avatar}
              width="24px"
              height="24px"
              className="avatar-md"
            />
          </MenuButton>
          <MenuList zIndex={1000}>
            {menuItemsConfig.map(({ id, label, onClick }) => (
              <MenuItem key={id} data-test-id={id} onClick={onClick}>
                {label}
              </MenuItem>
            ))}
          </MenuList>
        </Flex>
      </Menu>
    );
  };

  return <Flex>{renderAction()}</Flex>;
};
